(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/sport/quickplay-modal2/assets/javascripts/place-bet/place-bet-new-payment-flow.js') >= 0) return;  svs.modules.push('/components/sport/quickplay-modal2/assets/javascripts/place-bet/place-bet-new-payment-flow.js');
"use strict";


const logger = new svs.core.log.Logger('svs.sport.QuickplayModal.placeBetNewPayment');
const {
  getDisplayName,
  resolveITSProductId
} = svs.utils.products;
const {
  isMarketplaceWallet
} = svs.components.tipsen.wallet.walletHelpers;
const {
  createStandardPaymentFlow
} = svs.components.wagerPaymentFlow.standardFlow;
const {
  createMarketplacePaymentFlow
} = svs.components.wagerPaymentFlow.marketplaceFlow;
const {
  executePayment
} = svs.components.wagerPaymentFlow.executePayment;
const {
  WALLET_MARKETPLACE_PLAYER,
  WALLET_MARKETPLACE_RETAILER
} = svs.components.tipsen.wallet.walletType;
const {
  groupTypes
} = svs.components.marketplaceData.constants;
const {
  getPixHandler
} = svs.components.sport.pixHandler;
const getGroupType = type => {
  switch (type) {
    case WALLET_MARKETPLACE_PLAYER:
      return groupTypes.PRIVATE;
    case WALLET_MARKETPLACE_RETAILER:
      return groupTypes.RETAILER;
    default:
      logger.info("unsupported group type: ".concat(type));
  }
};


const createAndExecutePayment = async _ref => {
  let {
    productId,
    bag,
    closeCallback,
    hasMarketplaceWallet,
    unlockPaymentFlow,
    isPixMix,
    wallet,
    wagerToPay
  } = _ref;
  const pixHandler = getPixHandler({
    isPixMix
  });
  let paymentBuilder;
  const _successCallback = async () => {
    if (closeCallback) {
      closeCallback();
    }
    await pixHandler.fetch({
      productId,
      shouldGenerateNewPix: true
    });
  };
  if (hasMarketplaceWallet) {
    const walletMeta = wallet === null || wallet === void 0 ? void 0 : wallet.meta;
    const role = getGroupType(wallet.type);
    const isC2C = Boolean(role === groupTypes.PRIVATE);
    wagerToPay.setRole(role);
    if (isC2C) {
      wagerToPay.setActivatedDrawId(walletMeta.ActivatedDrawId);
    } else {
      wagerToPay.setActivatedDrawId(walletMeta.activatedDrawId);
      wagerToPay.setCommissionPercent(walletMeta.commissionPercent);
    }
    paymentBuilder = createMarketplacePaymentFlow({
      config: {
        haltPaymentOnException: true
      },
      wagers: [wagerToPay],
      isC2C
    });
  } else {
    paymentBuilder = createStandardPaymentFlow({
      config: {
        haltPaymentOnException: true
      },
      wagers: [wagerToPay]
    });
  }
  const {
    systemCost,
    systemType,
    drawNumber,
    rowPrice,
    productSizes,
    branding
  } = pixHandler.getProduct(productId);
  const keepOpenItem = {
    url: window.location.href,
    pixData: {
      productId,
      systemCost,
      systemType,
      rowPrice,
      drawNumber,
      productSizes,
      branding,
      isPixMix
    }
  };
  pixHandler.setKeepOpenItem(keepOpenItem);
  const [, error] = await executePayment(paymentBuilder, {
    userContext: {
      bag
    }
  });
  unlockPaymentFlow();
  if (!error) {
    await _successCallback();
  }
};

const placeBetNewPaymentFlow = async _ref2 => {
  let {
    productId,
    closeCallback,
    unlockPaymentFlow,
    wallet,
    rowPrice,
    isPixMix
  } = _ref2;
  const pixHandler = getPixHandler({
    isPixMix
  });
  const {
    systemCost,
    drawNumber
  } = pixHandler.getProduct(productId);
  const productName = getDisplayName(productId);
  if (!productName) {
    unlockPaymentFlow();
    logger.error("Error in placeBet: Invalid productId (".concat(productId, ")"));
    return;
  }

  const bag = "".concat(systemCost, ":").concat(productName, " ").concat(systemCost);
  const wagerBoardData = pixHandler.compose(productId);
  const wagerToPay = pixHandler.createPixWager({
    productId,
    wagerBoardData,
    drawNumber,
    rowPrice
  });
  const wagerProductId = resolveITSProductId(productId) || '';
  if (!wagerProductId) {
    logger.info('Warning in placeBetNewPaymentFlow: Sending wager without productID');
  }
  const hasMarketplaceWallet = isMarketplaceWallet(wallet);
  return createAndExecutePayment({
    productId,
    bag,
    closeCallback,
    hasMarketplaceWallet,
    unlockPaymentFlow,
    isPixMix,
    wallet,
    wagerToPay
  });
};
setGlobal('svs.components.sport.quickplayModal2.placeBet.placeBetNewPaymentFlow', placeBetNewPaymentFlow);

 })(window);